/* Pooch — mobile par product page ke neeche chipka "Add to Petkart" bar.
   - sirf product page, sirf mobile (<=749px)
   - tabhi dikhta hai jab asli Add button screen se upar chala jaye
   - apna form nahi banata: asli button ko hi click karta hai,
     isliye quantity / variant / cart drawer sab pehle jaisa chalta hai */
(function () {
  var MQ = '(max-width: 749px)';

  function money(el) {
    if (!el) return '';
    var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
    var m = t.match(/(?:Rs\.?|₹)\s?[\d,]+(?:\.\d{2})?/);
    return m ? m[0] : '';
  }

  function build() {
    if (document.querySelector('.pooch-stickybar')) return;
    if (!window.matchMedia || !window.matchMedia(MQ).matches) return;

    /* sirf product page — warna homepage ke quick-add button bhi pakad leta hai */
    if (location.pathname.indexOf('/products/') !== 0) return;

    var real = document.querySelector(
      '[id$="__main"] button[name="add"], [id$="__main"] add-to-cart-component button'
    );
    if (!real) return;
    var form = real.closest('form');
    if (!form || (form.getAttribute('action') || '').indexOf('/cart/add') < 0) return;

    var h1 = document.querySelector('h1');
    var priceEl = document.querySelector('[id$="__main"] [class*="price"]') || document.querySelector('[class*="price"]');
    var img = document.querySelector('[id$="__main"] img.product-media__image, [class*="media-gallery"] img');

    var bar = document.createElement('div');
    bar.className = 'pooch-stickybar';
    bar.innerHTML =
      '<div class="pooch-stickybar__info">' +
        (img ? '<img class="pooch-stickybar__img" alt="" src="' + img.currentSrc.split('?')[0] + '?width=120">' : '') +
        '<div class="pooch-stickybar__text">' +
          '<span class="pooch-stickybar__title"></span>' +
          '<span class="pooch-stickybar__price"></span>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="pooch-stickybar__btn"></button>';
    bar.querySelector('.pooch-stickybar__title').textContent = h1 ? h1.textContent.trim() : '';
    bar.querySelector('.pooch-stickybar__price').textContent = money(priceEl);
    var btn = bar.querySelector('.pooch-stickybar__btn');
    btn.textContent = (real.textContent || 'Add to Petkart').replace(/\s+/g, ' ').trim() || 'Add to Petkart';

    btn.addEventListener('click', function () {
      if (real.disabled) return;
      real.click();                    /* asli button — saara Shopify logic wahi chalayega */
    });

    document.body.appendChild(bar);

    /* asli button dikhe to bar chhupa do */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { bar.classList.toggle('is-on', !en.isIntersecting); });
      }, { rootMargin: '0px 0px -40px 0px' }).observe(real);
    } else {
      bar.classList.add('is-on');
    }

    /* sold out ho to bar bhi band */
    if (real.disabled) bar.classList.add('is-off');
  }

  function run() { try { build(); } catch (e) {} }
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
  if (window.matchMedia) {
    try { window.matchMedia(MQ).addEventListener('change', function () {
      var b = document.querySelector('.pooch-stickybar'); if (b) b.remove(); run();
    }); } catch (e) {}
  }
  run();
})();
